module.exports = __webpack_public_path__ + "static/media/bars.f15b4309.svg";